import _ from 'lodash';
import CommonUtil from './CommonUtil';

//Constants definition
var getKeyorValue = (Obj, param) => {
    // return Obj[param] || Object.keys(Obj).find(key => Obj[key].toLowerCase() === param.toLowerCase());
    return _.get(Obj, param) || _.get(_.invert(Obj), param)
}

export const GROUP_SPORT_PERIODS = {
    sportId: 0,
    groupPeriod: 1 
}

export const PERIODS_DESC = {
    periodNumber: 0,
    description: 1,
    shortDescription: 2
}

export const GRADING_UNIT_TYPE = {
    REGULAR: 'Regular',
    SETS: 'Sets',
    GAMES: 'Games'
}

export const TENNIS_COUNT_MORE_BET = {
    mlSets: 0,
    mlGames: 0,
    ml: 0,
    ouSets: 0,
    ouGames: 0,
    ou: 0,
    hdpSets: 0,
    hdpGames: 0,
    hdp:  0,
    ttSets: 0,
    ttGames: 0,
    tt: 0
}

export const AUTO_REFRESH_BETSLIP_TIME = 8 ; //  Default is 8s. If value is 0, the future will not support

export const EMPTY_VALUE = '';

export const SPORT_NAME = {
  VS: 'vs',
  ESPORTS: 'E-sports'
};

export const LIVE_CENTER = {
  LC: 'lc',
  ST: 'st',
  TV: 'tv'
};

export const ViewKeys = {
  classic: 'classicView',
  compact: 'compactView',
  standard: 'standardView',
  asia: 'asiaView',
  europe: 'europeView'
}

export const ViewKeysMapping = {
  classicView: 'CLASSIC',
  compactView: 'COMPACT',
  standardView: 'FUTURE',
  asiaView: 'ASIA',
  europeView: 'EUROPE'
}

export const ViewPath = {
  asiaView: '',
  compactView: 'compact',
  classicView: 'classic',
  europeView: 'euro',
  standardView: '',
}

export const PLAYER_TYPE = {
  CASH: 'CASH',
  CREDIT: 'CREDIT'
}

export const DEFAULT_DATES = [
  {
    text: 'All Dates',
    value: '',
    priority: 0
  },
  {
    text: 'Onwards',
    value: 'ONWARDS',
    priority: 999
  }
]

export const HOME_AWAY_LABEL = {
    0: {
        description: ["Home", "Away"],
        shortDescription: ["H", "A"]
    },
    33: {
        description: ["Player 1", "Player 2"],
        shortDescription: ["P1", "P2"]
    }
}

export const RunningStateExtraTime = ["1H ET", "2H ET", "HT ET", "END ET", "HTEX", "EEX"];

export const E_SPORT_ID = 12

export const PAGE_TITLE = {
  "homePageContainer": 'homePageTitle',
  "liveCasinoPageContainer": 'liveCasinoPageTitle',
  "casinoPageContainer": 'casinoPageTitle',
  "promotionPageContainer": 'promotionPageTitle'
}

export const PAGE_DESC = {
  "homePageContainer": 'homePageDesc',
  "liveCasinoPageContainer": 'liveCasinoPageDesc',
  "casinoPageContainer": 'casinoPageDesc',
  "promotionPageContainer": 'promotionPageDesc'
}


export const WALLET_METHOD = {
  SEAMLESS : 'SEAMLESS',
  TRANSFER : 'TRANSFER'
}

export const CASINO_GAME_TYPE = {
  AG: 'AG',
  PT: 'PT',
  IF: 'IF',
  SG: 'SG',
  agin: 'agin',
  diamond: 'diamond',
  sapphire: 'sapphire',
  iforium: 'iforium',
  DG: 'DG',
  EG: 'EG'
}

export const LIVE_CASINO_GAME_TYPE = {
  ION: 'ION',
  CR855: 'CR855',
  AG: 'AG',
}

export const LIVE_CASINO_GAME_MAPPING = {
  CR855: 'CR855_CASINO',
}

export const CASINO_CATEGORY_TYPE = {
  NORMAL: 'NORMAL',
  NEW: 'NEW'
}

export const PRODUCT_CODE = {
  SB: 'SB',
  CASINO: 'CASINO',
  LIVE_CASINO: 'LIVE_CASINO',
  AGIN: 'AGIN',
  PLAYTECH: 'PLAYTECH',
  IFORIUM: 'IFORIUM',
  SG: 'SG',
  AG: 'AG',
  CR855: 'CR855',
  ION: 'ION',
  VS: 'VS',
  GR: 'GR',
  ALL: 'ALL',
  AGIN_CASINO: 'AGIN Live Casino',
  HR: 'HR',
  BB: 'BB',
  DG: 'DG',
  EG: 'EG'
}
export const PRODUCT_NAME = {
    SB: 'Sportsbook',
    CASINO: 'Casino',
    AGIN: 'AGIN Live Casino',
    PLAYTECH: 'Playtech',
    IFORIUM: 'Featured Casino',
    AG: 'AG',
    CR855: 'CR855',
    ION: 'ION',
    VS: 'Virtual Sports',
    GR: 'Golden Race',
    ALL: 'All',
    LIVE_CASINO: 'Live Casino',
    BB: 'Bet Builder',
    DG: 'Dream Gaming',
    EG: 'Evolution Gaming'
}

export const NAVIGATION_B2B_ID = {
  ACCOUNT: 'account',
  MY_BETS: 'my-bets',
  STATEMENTS: 'statements',
  MESSAGES: 'messages',
  ANNOUNCEMENTS: 'announcements',
  BETTING_RULES: 'betting-rules',
  SPORTS_BETTING: 'sports-betting',
  MORE_MENU: 'more-menu',
  PROMOTION: 'promotion'
}

export const ACCOUNT_MENU_ID = {
  ACCOUNT: 'ACCOUNT',
  MY_BETS: 'MY_BETS',
  STATEMENTS: 'STATEMENTS',
  BALANCE: 'BALANCE',
  PROFILE: 'PROFILE',
  PREFERENCES: 'PREFERENCES',
  MESSAGES: 'MESSAGES',
  ANNOUNCEMENTS: 'ANNOUNCEMENTS',
  LOGOUT: 'LOGOUT',
  WITHDRAWAL: 'WITHDRAWAL',
}

export const ONLY_ESPORTS_TAB = [
  {
    label: "Esports",
    tabId: "ESPORTS"  
  }
]

export const ONLY_VS_TAB = {
    label: "Virtual Sports",
    tabId: "VS"  
}

export const DATE_TYPE_NAME = Object.freeze({
    ACCEPTED_DATE: 'Accepted date',
    GRADED_DATE: 'Graded date'
});

export const DATE_TYPE = Object.freeze({
    ACCEPTED_DATE: 'ACCEPTED_DATE',
    GRADED_DATE: 'GRADED_DATE',
    DEFAULT: ''
});

export const blockedCountries = {
  'AG': false,
  'AGIN': false,
  'ION': false,
  'CR855': false,
  'PLAYTECH': false,
  'IFORIUM': false
}

export const PLATFORM = {
  PC: 'PC',
  MOBILE: 'MOBILE'
}

export const STATUS = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE'
}

export const EVENT_STATUS = {
  O: 'O',
  I: 'I',
  H: 'H'
}

export const CLASSIC_COUNTDOWN = {
    LIVE: 20,
    NON_LIVE: 60,
    OUTRIGHT: 20,
    ZERO: 0
}

export const RoundRobinOption = {
    PARLAY: 'Parlay',
    TWO_LEGS: 'TwoLegRoundRobin',
    THREE_LEGS: 'ThreeLegRoundRobin',
    FOUR_LEGS: 'FourLegRoundRobin',
    FIVE_LEGS: 'FiveLegRoundRobin',
    SIX_LEGS: 'SixLegRoundRobin',
    SEVEN_LEGS: 'SevenLegRoundRobin',
    EIGHT_LEGS: 'EightLegRoundRobin'
}

export const ClassicOddsResp = {
    event: 'e',
    liveUpdate: 'ul',
    update: 'u',
    liveEvent: 'l',
    normalEvent: 'n',
    parlayEvent: 'pn',
    parlayLiveEvent: 'pl',
    parlayUpdateEvent: 'pu'
}

export const UpdateOdds = {
    periodNum: 0,
    betType: 1,
    selectionType: 2,
    hdp: 3,
    odds: 4,
    oddsFm: 5,
    lineId: 6,
    oldLineId: 7,
    alt: 8,
    signal: 9,
    status: 10,
    action: 11,
    eventId: 12
}

export const UpdateScore = {
    score: 0,
    time: 1,
    action: 2,
    eventId: 3
}

export const UpdateCard = {
    card: 0,
    action: 2,
    eventId: 3
}

export const UpdateRunningState = {
    runningPeriod: 0,
    runningTime: 1,
    action: 2,
    eventId: 3
}

export const SportEventsUpdate = {
    sportId: 0,
    update: 1,
    version: 2,
    running: 3
}

export const TeamType = {
    home: 0,
    away: 1,
    draw: 2,
    team1: 0,
    team2: 1
}

export const ClassicSportEvents = {
    sportId: 0,
    sportName: 1,
    leagueEvents: 2,
    group: 3,
    version: 4,
    hasDrawPrice: 5
}

export const ClassicLeagueEvents =  {
    id: 0,
    name: 1,
    events: 2,
    maxMoneyLine: 5,
    maxHDP: 6,
    maxTotal: 7,
    maxTeamTotals: 8,
    maxTotalForTeamTotals: 9
}

export const ClassicEvent = {
    id: 0,
    homeName: 1,
    awayName: 2,
    time: 3,
    running: 4,
    live: 5,
    periods: 6,
    scores: 7,
    redCards: 8,
    teamType: 9,
    baseBall: 10,
    homePitcher: 11,
    awayPitcher: 12,
    runningTime: 13,
    runningPeriod: 14,
    eventStatus: 15,
    liveCenter: 16,
    liveTV: 17,
    liveCenterId: 18,
    moreBets: 19,
    totalOutrightOdds: 20,
    maxMoneyLine: 21,
    maxHdp: 22,
    maxTotal: 23,
    maxTeamtotals: 24,
    rotNum: 25
}

export const Market = {
    Early: 0,
    Today: 1,
    Live: 2,
    ALL: 3,
    Parlay: 4,
    Outright: 5,
    CorrectScore: 6,
    Teasers: 7,
    DoubleChance: 8,
    Specials: 9,
    OutrightNormals: 10
}

export const EsportMarket = {
  None: -1,
  PreGame: 0,
  Soon: 1,
  Live: 2,
  All: 3,
  Parlay: 4,
  Outright: 5,
  CorrectScore: 6,
  Teasers: 7
}

export const MarketLine1x2 = {
    awayTeam: 0,
    homeTeam: 1,
    draw: 2,
    id: 3,
    alt: 4,
    maxBet: 5,
    redBlueCircleOption: 6
}

export const MarketLineOU = {
    handicap: 0,
    points: 1,
    overOdds: 2,
    underOdds: 3,
    id: 4,
    alt: 5,
    maxBet: 6,
    redBlueCircleOption: 7
}

export const TeaserMarketLineOU = {
  overPoint: 0,
  underPoint: 1,
  teaserId: 2,
  selectedPoint: 3,
  id: 4,
  alt: 5,
  maxBet: 6
}

export const TeaserMarketLineHDP = {
  homePoint: 0,
  awayPoint: 1,
  homeFav: 2,
  awayFav: 3,
  teaserId: 4,
  selectedPoint: 5,
  id: 6,
  alt: 7,
  maxBet: 8
}

export const TeaserEventPeriodHDPOU = {
  hdp: 0,
  ou: 1,
  ml: 2,
  periodNum: 3,
  name: 4,
  homeFav: 5,
  awayFav: 6
}

export const MarketLineHDP = {
    awaySpread: 0,
    homeSpread: 1,
    handicap: 2,
    homeOdds: 3,
    awayOdds: 4,
    homeFav: 5,
    awayFav: 6,
    id: 7,
    alt: 8,
    maxBet: 9,
    redBlueCircleOption: 10
}

export const MarketLineTeamTotalsOU = {
    homeTeam: 0,
    awayTeam: 1,
    total: 2
}

export const EventPeriodHDPOU = {
    handicap: 0,
    totalOU: 1,
    moneyLine: 2
}

/**
 * Possible update actions
 */
export const UpdateAction = {
    UPDATE_ODD: 0,
    UPDATE_HANDICAP: 1,
    ADD_EVENT: 2,
    DELETE_EVENT: 3,
    ADD_MARKET_LINE: 4,
    DELETE_MARKET_LINE: 5,
    DELETE_PERIOD: 6,
    ADD_PERIOD: 7,
    EVENT_STATUS: 8,
    RUNNING_STATE: 9,
    UPDATE_SCORE: 10,
    UPDATE_CARD: 11,
    UPDATE_INFO: 12
}

export const Period = {
    FullTime: 0,
    HalfTime: 1,
    TeamTotal: 2,
    Proposition: 3
} 

export const EventOrder = {
    Time: 0,
    League: 1
}

export const Currency = {
    USD: 'USD',
    CNY: 'CNY',
    IDR: 'IDR'
}

export const OddsFormat = {
    American: 0,
    Decimal: 1,
    HongKong: 2,
    Indonesian: 3,
    Malay: 4,
    AM: 0,
    EU: 1,
    HK: 2,
    ID: 3,
    MY: 4
}
export const OddsFormatMB = {
  Decimal: 1,
  HongKong: 2,
  Indonesian: 3,
  Malay: 4,
  American: 0,
}

export const OddsFormatHR = {
  AM: 0,
  EU: 1,
  HK: 2,
  ID: 3,
  MY: 4
}

export const RBOddsFormatTrans = {
  0: 'AM',
  1: 'EU',
  2: 'HK',
  3: 'ID',
  4: 'MY',
}

export const ODDS_FORTMAT_BB = {
    AM: 0,
    EU: 1,
    HK: 2,
    ID: 3,
    MY: 4
  }

export const MarketHR = {
  ALL: 0,
  WIN: 1,
  PLACE: 2,
}

export const getOddsFormatById = (oddsFormat) => {
  return _.invert(OddsFormatMB)[oddsFormat] || Object.keys(OddsFormatMB)[0];
};

export const getOddsFormatByIdHR = (oddsFormat) => {
  return _.invert(OddsFormatHR)[oddsFormat] || Object.keys(OddsFormatHR)[0];
};

export const getOddsFormatNameRB = (oddsFormat) => {
  return _.invert(RBOddsFormatTrans)[oddsFormat] || Object.keys(RBOddsFormatTrans)[0];
};

export const getOddsFormatNameBB = (oddsFormat) => {
    return _.invert(ODDS_FORTMAT_BB)[oddsFormat] || Object.keys(ODDS_FORTMAT_BB)[0];
  };
  

export const getMarketTypeHorseRacing = (marketId) => {
  return _.invert(MarketHR)[marketId] || Object.keys(MarketHR)[0];
};

export const OddsFormatTrans = {
  0: 'AmericanOdds',
  1: 'Decimal Odds',
  2: 'HKOdds',
  3: 'IndonesianOdds',
  4: 'MaLayOdds',
}

export const OddsFormatVS = {
    American: 'AM',
    Decimal: 'EU',
    HongKong: 'HK',
    Indonesian: 'ID',
    Malay: 'MY'
}

export const OddsFormatStatement = {
  American: 'A',
  Decimal: 'E',
  HongKong: 'H',
  Indonesian: 'I',
  Malay: 'M'
}

export const Mode = {
    NORMAL: 0,
    PARLAY: 1,
    OUTRIGHT: 2,
    TEASER: 3,
    VS_NORMAL: 4,
    LC: 5,
    INPLAY: 6,
    PARLAY_MARKET: 7,
    OUTRIGHT_MARKET: 8,
    TEASER_MARKET: 9,
    FAVORITE: 10,
    VS_PARLAY: 11,
    TV: 12,
    SEARCH: 13,
    ST: 14,
}

export const BetTypeGroup = {
    HDP_OU: 1,
    ML_1X2: 2,
    TEAM_TOTAL: 100,
    TEASERS: 4,
    MIX_PARLAY: 101,
    OUTRIGHT: 102,
    CORRECT_SCORE: 103,
    DOUBLE_CHANCE: 104,
    SPECIALS: 105,
}

export const E_SPORT_PERIODS = {
    0: 'Match',
    1: 'Map 1',
    2: 'Map 2',
    3: 'Map 3',
    4: 'Map 4',
    5: 'Map 5',
    6: 'Map 6',
    7: 'Map 7',
}

export const BetType = {
    THE_1X2: 1,
    HANDICAP: 2,
    OU: 3,
    HOME_TOTALS: 4,
    AWAY_TOTALS: 5,
    MIX_PARLAY: 6,
    TEASER: 7,
    MANUAL_PLAY: 8,
    SPECIALS: 9,
    OE: 97,
    OUTRIGHT: 99
}

export const RBBetType = {
  SINGLE: "SINGLE",
  PARLAY: "PARLAY",
}

export const CommonBetType = {
    SINGLE: "SINGLE",
    PARLAY: "PARLAY",
  }

export const MarketType = {
  ALL: 'ALL',
  _1LINE: '_1LINE',
  _3LINES: '_3LINES',
  _5LINES: '_5LINES',
}

export const EventSortingType = {
  SortByTime: 'TIME',
  SortByDefault: 'LEAGUE',
}

export const ClassicBetType = {
    MONEYLINE: 1,
    HANDICAP: 2,
    TOTAL: 3
}

export const BetTypeDisp = {
  '1x2': '1x2',
  'HDP': 'Handicap',
  'OU': 'Over/Under',
}

export const BetTypeSortDisp = {
  '1x2': '1x2',
  'HDP': 'HDP',
  'OU': 'OU',
};

export const OddsSelection = {
  'AWAY': 'AWAY',
  'HOME': 'HOME',
  'OVER': 'OVER',
  'UNDER': 'UNDER',
};

export const OddsMode = {
    Single: 0,
    Double: 1
}

export const MarketFilter = {
    All: 100,
    _1Line: 1,
    _3Lines: 3,
    _5Lines: 5,
    Error: -1
}

export const MarketFilterTrans =  {
  100: 'AllMarkets',
  1: '1 Line',
  3: '3 Lines',
  5: '5 Lines'
}

export const StatementPeriodFilterTrans = {
  period: 'Period',
  currentMonth: 'Current Month',
  lastMonth: 'Last Month',
}

export const SelectionType = {
    HOME: 0,
    AWAY: 1,
    DRAW: 2,
    OVER: 3,
    UNDER: 4,
    HOME_OVER: 5,
    HOME_UNDER: 6,
    AWAY_OVER: 7,
    AWAY_UNDER: 8,
    AAAA: 9
}

export const SportGroup = {
    SOCCER: 0,
    BASKETBALL: 1,
    TENNIS: 2,
    OTHERS: 3,
    BASEBALL: 4,
    ESPORT: 5,
    FOOTBALL: 6
}

export const TennisGradingUnit = {
    REGULAR: 'regular',
    SETS: 'Sets',
    GAMES: 'Games'
}

export const VsBetType = {
    ITEM3W: 2,
    HC: 4,
    TO: 5,
    FT3W: 6,
    FT2W: 7,
    FTNW: 8,
    OUTRIGHT: 10,
    PARLAY: 99
}

export const HeadToHead = 'Head To Head';

export const VsWagerSelectionKeyTrans = {
  '1st': 'period',
  '2nd': 'Q2',
  '3rd': 'Q3',
  '4th': 'Q4',
}

export const VsSelectionKeyTrans = {
  '1st': 'q1',
  '2nd': 'q2',
  '3rd': 'q3',
  '4th': 'q4',
}

export const VsSubTypeKeyTrans = {
  FT2W_89_4: 'Winner Game',
  FT2W_11_4: 'Winner Set'
}

export const VsSelection = {
  GOLDEN_RACE: 'Golden Race'
}

export const RaceSportId = {
    HORSE: 5,
    DOG: 6
}

export const EventPeriodFullOdds = {
    TEAM_OU: 0,
    HDP: 1,
    OU: 2,
    ML: 3
}

export const BreadCrumb = {
    Home: 'home',
    Sport: 'sport',
    Country: 'country',
    League: 'league',
    Event: 'event',
    Favorite: 'favorite',
    Date: 'date',
    MixParlay: 'mixparlay',
    Teaser: 'teaser',
    Level: {
        Home: 0,
        Sport: 1,
        Country: 2,
        League: 3,
        Event: 4,
        Favorite: 5,
        MixParlay: 6,
        Teaser: 7
    }
}

export const Error = {
    MSG01: 'Please login first!',
    MSG02: 'Maximun is 8 selections.',
    MSG03: 'Sorry, proccessing to add selection!',
    INTERNAL: 'INTERNAL_ERROR',
    SESSION: 'Session timeout. Please login again!'
}

export const Category = {
    MEMBER_SIGNUP: 'MEMBER_SIGNUP',
    MEMBER_ADD_BANK: 'MEMBER_ADD_BANK'
}

export const Product = {
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE',
    MAINTENANCE: 'MAINTENANCE',
    CLOSED: 'CLOSED',
    WAGERING_SUSPENDED: 'WAGERING_SUSPENDED'
}

export const UserStatus = {
  ACTIVE: "ACTIVE",
  SUSPENDED: "SUSPENDED",
  SUSPENDED_BY_COMPANY: "SUSPENDED_BY_COMPANY",
  INACTIVE: "INACTIVE",
  CLOSED: "CLOSED" 
}

export const ParlayMenu = {
    MAIN_SPORTS: [29, 33, 4, 3, 12]
}

export const LoginStatus = {
    INVALID_USER_OR_PASS: 0,
    LOGIN_FAILED: -1,
    WRONG_COUNTRY: -2,
    ACCOUNT_UNVERIFIED: -3,
    ACCOUNT_SUSPENDED: -4,
    WRONG_ODDS_FORMAT: -5,
    ACCOUNT_MIGRATED_TO_PS3838: -6,
    TRY_IN_20_MINS: '4',
    TRY_IN_FEW_MINS: '5',
    SUCCESS_WITH_STT_1: 1,
    SUCCESS_WITH_STT_2: 2,
    SUCCESS_WITH_STT_3: 3,
    SUCCESS_WITH_STT_6: 6,
    SUCCESS_WITH_STT_7: 7, // No securiy question or answer
    EXCEED_SESSION_TIME_LIMIT: 8,
    BLOCKED_IP_RING_FENCING: 13,
    INVALID_CAPTCHA: 15,
    INVALID_TRUSTCODE: 14
}

export const DateIndex = {
    ALL_DATE: 8
}

export const SportItemMap = {
    id: 0,
    name: 1,
    totalEvents: 2,
    totalLines: 3,
    running: 4,
    betTypeSummary: 5,
    liveEvents: 6,
    todayEvents: 7,
    earlyEvents: 8,
    parlayEvents: 9,
    group: 10,
    outrightEvents: 11,
    correctScoreEvents: 12,
    todayLeagues: 13,
    earlyLeagues: 14,
    directPeriodsFolders: 15,
    specialEvents: 16,
    doubleChanceEvents: 17,
    horseRacingEvents: 19,
}

export const BET_TYPE_HORSE_RACING = {
    All: 0,
    WIN_rb: 1,
    PLACE_rb: 2
}

export const ESportItemMap = {
  id: 0,
  name: 1,
  code: 2,
  allLeagues: 3,
  totalEvents: 4,
  totalLines: 5,
  running: 6,
  betTypeSummary: 7,
  liveEvents: 8,
  todayEvents: 9,
  earlyEvents: 10,
  parlayEvents: 11,
  group: 12,
  outrightEvents: 13,
  correctScoreEvents: 14,
  directPeriodsFolders: 17,
  specialEvents: 18
}

export const BetTypeSummaryMap  = {
    running: 0,
    group: 1,
    totalLines: 2,
    totalEvents: 3
}

export const SportEventsIndex = {
    'id': 0,
    'name': 1,
    'leagues': 2
};
export const LeagueEventsIndex = {
    'id': 0,
    'name': 1,
    'events': 2
};
export const EventIndex = {
    'id': 0,
    'homeName': 1,
    'awayName': 2,
    'lines': 3,
    'time': 4,
    'running': 5,
    'live': 6,
    'moreBets': 7,
    'periods': 8,
    'scores': 9,
    'redCards': 10,
    'teamType': 11,
    'baseBall': 12,
    'homePitcher': 13,
    'awayPitcher': 14,
    'runningTime': 15,
    'runningPeriod': 16,
    'eventStatus': 17,
    'liveCenter': 18,
    'liveTV': 19,
    'liveCenterId': 20,
    'totalMarkets': 21,
    'parlayRestriction': 22,
    'totalOutrightOdds': 23,
    'rotNum': 26
};

export const DummyEventTennis = {
    'id': 0,
    'homeName': 1,
    'awayName': 2,
    'lines': 3,
    'time': 4,
    'running': 5,
    'live': 6,
    'moreBets': 7,
    'periods': 8,
    'scores': 9,
    'redCards': 10,
    'teamType': 11,
    'baseBall': 12,
    'homePitcher': 13,
    'awayPitcher': 14,
    'runningTime': 15,
    'runningPeriod': 16,
    'eventStatus': 17,
    'liveCenter': 18,
    'liveTV': 19,
    'liveCenterId': 20,
    'totalMarkets': 21,
    'parlayRestriction': 22,
    'totalOutrightOdds': 23,
    'rotNum': 26,
    'parentId': 27,
    'gradingUnit': 28
};

export const PointSportList = [1, 3, 4, 12, 17, 18, 19, 33];

export const winRiskSupportedArr =[OddsFormat.American, OddsFormat.Decimal];

export const SPORTS_ICON_BB = (value) => {
    const SPORTS_ICON = {
        1: "soccer",
        2: "basketball",
        3: "ice-hockey",
        4: "american-football",
        5: "baseball",
        7: "custom",
    }
    return getKeyorValue(SPORTS_ICON, value);
}

export const SPORTS_ICON = (value) => {
  const SPORTS_ICON = {
    1: "badminton",
    2: "bandy",
    3: "baseball",
    4: "basketball",
    6: "mma",
    5: "beach-volleyball",
    7: "chess",
    8: "cricket",
    9: "curling",
    10: "darts",
    11: "Darts",
    12: "esports",
    13: "fieldhockey",
    14: "floorball",
    15: "football",
    16: "futsal",
    17: "golf",
    18: "handball",
    19: "hockey",
    20: "horse-racing",
    22: "mma",
    26: "rugby-league",
    27: "rugby-union",
    28: "snooker",
    29: "soccer",
    24: "politics",
    30: "softball",
    31: "squash",
    33: "tennis",
    32: "table-tennis",
    34: "volleyball",
    35: "volleyball",
    36: "waterpolo",
    39: "aussie-rules",
    40: "alpine-skiing",
    41: "biathlon",
    42: "skijumping",
    43: "cross-country",
    44: "formula-1",
    45: "cycling",
    46: "bobsleigh",
    47: "figureskating",
    48: "freestyleskiing",
    49: "luge",
    50: "nordiccombined",
    51: "shorttrack",
    52: "skeleton",
    53: "snowboarding",
    54: "speedskating",
    55: "olympics",
    56: "athletics",
    57: "crossfit",
    58: "entertainment",
    59: "virtual-dog",
    60: "drone-racing",
    62: "poker",
    63: "motorsport",
        1000: "horse-racing",
        1001: 'horseracingspecials'
  }
  return getKeyorValue(SPORTS_ICON, value);
}

export const ALL_SPORTS = {
  29: "Soccer",
  33: "Tennis",
  4: "Basketball",
  15: "Football",
  3: "Baseball",
  17: "Golf",
  19: "Hockey",
  34: "Volleyball",
  26: "Rugby League",
  22: "Mixed Martial Arts",
  18: "Handball",
  12: "E Sports",
  39: "Aussie Rules",
  6: "Boxing",
  27: "Rugby Union",
  28: "Snooker",
  45: "Cycling",
  32: "Table Tennis",
  1: "Badminton",
  2: "Bandy",
  5: "Beach Volleyball",
  7: "Chess",
  8: "Cricket",
  9: "Curling",
  10: "Darts",
  11: "Darts (Legs)",
  13: "Field Hockey",
  14: "Floorball",
  16: "Futsal",
  20: "Horse Racing",
  24: "Politics",
  30: "Softball",
  31: "Squash",
  35: "Volleyball (Points)",
  36: "Water Polo",
  40: "Alpine Skiing",
  41: "Biathlon",
  42: "Ski Jumping",
  43: "Cross Country",
  44: "Formula 1",
  46: "Bobsleigh",
  47: "Figure Skating",
  48: "Freestyle Skiing",
  49: "Luge",
  50: "Nordic Combined",
  51: "Short Track",
  52: "Skeleton",
  53: "Snow Boarding",
  54: "Speed Skating",
  55: "Olympics",
  56: "Athletics",
  57: "Crossfit",
  58: "Entertainment",
  59: "Archery",
  60: "Drone Racing",
  62: "Poker",
  63: "Motorsport",
  64: "Simulated Games",
  65: "Sumo",
  1000: "Horse Racing",
  1001: "Horse Racing Specials"
}

export const SPORT = (value) => {
  return getKeyorValue(ALL_SPORTS, value);
}

export const FavouriteSport = {
    id: 0,
    count: 1,
    name: 2,
    events: 3,
    piority: 4,
    running: 5
}
export const CHECKED = {
    NONE: "NONE",
    RISK: "RISK",
    WIN: "WIN",
    BASE: "BASE"
}

export const OptionKeys = {
    settings: 'settings',
    date: "date",
    time: "time",
    line: "line",
    sort: "sort",
    view: "view",
    odds: "odds",
    sound: "sound",
    selectLeagues: "select_leagues",
}

export const TeaserSports = {
  Basketball: 4,
  Football: 15
}

export const TeaserType = {
  id: 0,
  name: 1,
  points: 2
}

export const TeaserKeys = {
  teaserTypes: 'teaser-types',
  teaserPoints: 'teaser-points',
  teaserTypesPoints: 'teaser-types-points'
}

export const lcSportsSupport = [29, 33, 4];

export const LocalePath = {
  en_US: "en",
  zh_CN: "zh-cn",
  zh_TW: "zh-tw",
  id_ID: "id",
  vi_VN: "vi",
  ko_KR: "ko",
  ja_JP: "ja",
  km_KH: "km",
  th_TH: "th",
  he_IL: "he",
  es_ES: "es",
  de_DE: "de",
  fr_FR: "fr",
  pt_BR: "pt",
  ru_RU: "ru",
  tr_TR: "tr",
  hi_IN: "hi",
  hy_AM: "hy",
  ka_GE: "ka",
  uk_UA: "uk",
  sv_SE: "sv"
    ,fi_FI: "fi",
    nb_NO: "no",
  it_IT: "it"
}
export const LOCALE_PATH_BB = {
    en_US: "en",
    zh_CN: "zh",
    zh_TW: "zh",
    id_ID: "id",
    vi_VN: "vi",
    ja_JP: "ja",
    th_TH: "th",
    es_ES: "es-es",
    fr_FR: "fr",
    pt_BR: "pt-br",
    ru_RU: "ru",
    tr_TR: "tr"
}

export const LangCodeBB = (value) => {
    return LOCALE_PATH_BB[`${value}`] || "";
  }

export const URL_VS_SPORTS_CODE = ['vs-vfwc','vs-vf','vs-vbl','vs-vflm','vs-vto','vs-vhc','vs-vdr']

export const VirtualSports = {
  VIRTUAL_SOCCER_WORLD_CUP: {
    id: 'VFWC',
    code: 'vfwc',
    name: 'Virtual Soccer World Cup',
  },
  VIRTUAL_SOCCER_NATIONS_CUP: {
    id: 'VFNC',
    code: 'vf',
    name: 'Virtual Soccer Nations Cup',
  },
  VIRTUAL_BASKETBALL: {
    id: 'VBL',
    code: 'vbl',
    name: 'Virtual Basketball',
  },
  VIRTUAL_SOCCER_LEAGUE: {
    id: 'VFL',
    code: 'vflm',
    name: 'Virtual Soccer League',
  },
  VIRTUAL_TENNIS: {
    id: 'VTO',
    code: 'vto',
    name: 'Virtual Tennis',
  },
  VIRTUAL_HORSES: {
    id: 'VHC',
    code: 'vhc',
    name: 'Virtual Horses',
  },
  VIRTUAL_DOGS: {
    id: 'VDR',
    code: 'vdr',
    name: 'Virtual Dogs',
  }
}

export const VirtualSportsName = {
  VIRTUAL_SOCCER_WORLD_CUP: 'Virtual Soccer World Cup',
  VIRTUAL_SOCCER_NATIONS_CUP: 'Virtual Soccer Nations Cup',
  VIRTUAL_BASKETBALL: 'Virtual Basketball',
  VIRTUAL_SOCCER_LEAGUE: 'Virtual Soccer League',
  VIRTUAL_TENNIS:'Virtual Tennis',
  VIRTUAL_HORSES:'Virtual Horses',
  VIRTUAL_DOGS: 'Virtual Dogs'
}

export const VirtualSportsCode = {
  VIRTUAL_SOCCER_WORLD_CUP: 'VFWC',
  VIRTUAL_SOCCER_NATIONS_CUP: 'VFNC',
  VIRTUAL_BASKETBALL: 'VBL',
  VIRTUAL_SOCCER_LEAGUE: 'VFL',
  VIRTUAL_TENNIS:'VTO',
  VIRTUAL_HORSES:'VHC',
  VIRTUAL_DOGS: 'VDR'
}


export const PARLAY_SPORTS = {
    29: "Soccer",
    4: "Basketball",
    12: "Esports",   
    3: "Baseball",
    33: "Tennis",
}

export const SPORT_MARKET_TYPES = {
    FULL_TIME: '0',
    HALF_TIME: '1',
    TEAM_TOTAL: '100',
    PARLAY: '101',
    PROPOSITION: '102',
    TEASER: '103'
}

export const SPORT_MARKET_LABEL = (type) => {
    var TYPES = {
        100: 'Team Totals - All available periods',
        102: 'Propositions / Future'
    };

    return getKeyorValue(TYPES, type);
}
export const freshchat = {
  logo:'https://fc-use1-00-pics-bkt-00.s3.amazonaws.com/0fa0d81d77a8ddde9d603a584dfef403dde281de7aa5042dfe68eaba966926aa/f_marketingpicFull/u_984596ae549e17dd9bb7d5df6945250c8e91d107a15ed344ad18f7f8ea3c3333/img_1527535765193.jpeg',
  token: 'b55b3c16-c920-4424-b212-420101691846',
  appName: 'Pinnacle',
  locale:'zh-HANS'
};

export const ERROR_CODE = {
  SAME_GAME_DIFFERENT_PICK: 'SAME_GAME_DIFFERENT_PICK',
  SELECTING_PICK_DIFFERENT_SPORT: 'SELECTING_PICK_DIFFERENT_SPORT',
  SELECTING_PICK_DIFFERENT_TYPE: 'SELECTING_PICK_DIFFERENT_TYPE',
  SELECTING_PICK_DIFFERENT_POINT: 'SELECTING_PICK_DIFFERENT_POINT',
}

export const LINE_OFFERING_TYPE = {
  ALL : 'All',
  TODAY: 'Today',
  LIVE: 'Live',
}

export const PARLAY_TAB_ITEMS = {
  ACCUMULATOR : 'Accumulators',
  TEASERS: 'Teasers'
  
}

export const SideBarType = {
    PROMOTION: 1, 
    WINNINGRIGHTNOW: 3, 
    MYLASTWINS: 2, 
    TOPWINNERS: 4, 
    RECENTLYPLAYED: 5, 
    JACKPOTS: 6,
    HOT_CASINO_GAME: 7
 }

 export const CASINO_TYPES = {
    LIVE_CASINO: 'CASINO_LIVE_IFORIUM', 
    CASINO: 'CASINO_IFORIUM',
    ALL: 'ALL'
 }

 export const WagerMyBetMap = {
  wagerId: 0,
  status: 11,
  odds:18,
  stake: 22,
  wagerSelections: 37,
  toWin: 41,
  toRisk: 42
}

/**
 * Periods for right column of odds page layout.
 * Esports: array contains maximum 3 periods
 * Others: array contains only 1 periods
 * Default: period value is 1
 */
export const PERIODS_RIGHT_ODDS_LAYOUT = {
  12: [1,2,3],
  19: [6]
}

/** 
 * More bet will not return all data of period in the PERIODS_MAIN_ODDS. 
 * It just returns all remaining odds of period that not in PERIODS_MAIN_ODDS.
 */
export const PERIODS_MAIN_ODDS = {
  19: "0,6"
}

export const PERIODS_MAIN_LABEL = {
    19: 19
};

export default class BettingSportMenuMap {
  static isShowTodayGames(sport) {
    return sport[this.BettingSportItemMap.today];
  }

  static getLiveGames(sport) {
     return sport[this.BettingSportItemMap.liveGames];
  }

  static getPreGames(sport) {
    return sport[this.BettingSportItemMap.preGames];
  }

  static getPropositionGames(sport) {
    return sport[this.BettingSportItemMap.propositionGames];
  }

  static getGamesByCountry(sport) {
    return sport[this.BettingSportItemMap.gamesByCountry];
  }

  static getSportName(sport) {
    return sport[this.BettingSportItemMap.sportName];
  }

  static getSportId(sport) {
    return sport[this.BettingSportItemMap.sportId];
  }

  static getSubMenuTitle(subMenu) {
    return subMenu[this.BettingSubMenuItemMap.title];
  }

  static getSubMenuData(subMenu) {
    return subMenu[this.BettingSubMenuItemMap.data];
  }

  static isProposition(subMenu) {
    return subMenu[this.BettingSubMenuItemMap.isProposition];
  }
  
  
  static getLeagueName(leagueItem) {
    return leagueItem[this.LeagueItemMap.leagueName];
  }

  static getLeagueId(leagueItem) {
    return leagueItem[this.LeagueItemMap.leagueId];
  }
  
  static getEventIdByLeague(leagueItem) {
    return leagueItem[this.LeagueItemMap.eventId];
  }

  static getCategory(leagueItem) {
    return leagueItem[this.LeagueItemMap.category];
  }

  static getOriginCategory(leagueItem) {
    return leagueItem[this.LeagueItemMap.originCategory];
  }

  static allowParlay(leagueItem) {
    return leagueItem[this.LeagueItemMap.allowParlay];
  }

  static getClosingSoonEventName(event) {
    return event[this.ClosingSoonEvent.eventName];
  }

  static getClosingSoonEventId(event) {
    return event[this.ClosingSoonEvent.eventId];
  }

  static getClosingSoonEventTime(event) {
    return event[this.ClosingSoonEvent.time];
  }

  static getSportIdOfClosingSoonEvent(event) {
    return event[this.ClosingSoonEvent.sportId];
  }

  static getLeagueIdOfClosingSoonEvent(event) {
    return event[this.ClosingSoonEvent.leagueId];
  }

  static BettingSportItemMap = {
    sportId: 0,
    sportName: 1,
    today: 2,
    liveGames: 3,
    preGames: 4,
    propositionGames: 5,
    gamesByCountry: 6, // included proposition games
  }

  static BettingSubMenuItemMap = {
    title: 0,
    isProposition: 1,
    data: 2
  }

  static LeagueItemMap = {
    leagueName: 0,
    leagueId: 1,
    priority: 2,
    category: 3,
    originCategory: 4,
    eventId: 5,
    allowParlay: 6
  }

  static ClosingSoonEvent = {
     eventName: 0,
     eventId: 1,
     time: 2,
     rotNum: 3,
     sportId: 4,
     leagueId: 5
  }

}

export const StatementOddsFormat = {
  Decimal: "E",
  Indonesian: "I",
  Malay: "M",
  HongKong: "H",
  American: "A"
}

export const oddsFormatKeys = {
    Decimal: {
      key: OddsFormat.Decimal,
      icon: 'decimal',
    },
    HongKong: {
      key: OddsFormat.HongKong,
      icon: 'hongkong',
    },
    Indonesian: {
      key: OddsFormat.Indonesian,
      icon: 'indonesian',
    },
    Malay: {
      key: OddsFormat.Malay,
      icon: 'malay',
    },
    American: {
      key: OddsFormat.American,
      icon: 'american',
    },
  }

  export const BUTTON_SELECTION = {
    BET_SLIP: 'BET_SLIP',
    PENDING_BETS: 'PENDING_BETS',
    ALL_EVENTS: 'ALL_EVENTS',
    MY_FAVOURITES: 'MY_FAVOURITES',
    TOP_LEAGUES: 'TOP_LEAGUES'
  }

  export const SPORT_TABS = {
    SPORTS: 'SPORTS',
    ESPORTS: 'ESPORTS',
    PARLAYS: 'PARLAYS',
    VIRTUAL_SPORTS: 'VIRTUAL_SPORTS'
  }

  export const MARKET_TABS = {
    LIVE: 'LIVE',
    TODAY: 'TODAY',
    EARLY: 'EARLY',
    NEXT_THREE: 'NEXT-THREE',
}

export const ESPORT_MARKET_TABS = {
  LIVE: 'LIVE',
  SOON: 'SOON',
  PREGAME: 'PREGAME',
}

export const NEXT_THREE_TAB = {
    label: 'Next three',
    tabId: 'NEXT-THREE'
}
  export const COMPACT_SPORT_MENU = {
    sportId: 0,
    liveMenu: 1,
    todayMenu: 2,
    earlyMenu: 3,
    nextThree: 1,
  }


  export const DIRECT_PERIODS_FOLDER_SUM = {
    periodNumber: 0,
    totalEvents: 1
  }

  export const MORE_BETS_MARKET = {
    ALL: 'All',
    '1ST_TEAMTOTAL': '1_tt',
    '1ST_MONEY_LINE': '1_ml',
    '1ST_HANDICAP_OU': '1_hou',
    '1ST_1X2': '1_1x2',
    MATCH_TEAMTOTAL: '0_tt',
    MATCH_MONEY_LINE: '0_ml',
    MATCH_HANDICAP_OU: '0_hou',
    MATCH_1X2: '0_1x2',
    Outright: 'Outright',

  }  
  export const BETSLIP_TABS = {
    SINGLE: 'SINGLE',
    PARLAY: 'PARLAY',
    TEASERS: 'TEASERS'
  }

  export const WinRiskType = {
    RISK: "RISK",
    WIN: "WIN",
    BASE: "BASE"
}
export const FullEvent = {
  sportId: 0,
  leaugeId: 1,
  sportGroup: 2,
  event: 3,
  version: 4
}
export const EventDetail = {
  id: 0,
  homeName: 1,
  awayName: 2,
  lines: 3,
  time: 4,
  running: 5,
  live: 6,
  moreBets: 7,
  periods: 8,
  scores: 9,
  redCards: 10,
  teamType: 11,
  baseBall: 12,
  homePitcher: 13,
  awayPitcher: 14,
  runningTime: 15,
  runningPeriod: 16,
  eventStatus: 17,
  liveCenter: 18,
  liveTV: 19,
  liveCenterId: 20,
  totalMarkets: 21,
  parlayRestriction: 22, //Value indicate parlay support: 0: not support, 1: support, 2: support 1 leg parlay.
  totalOutrightOdds: 23,
  originalHomeName: 24,
  originalAwayName: 25,
    rotationNumber: 26,
    gradingUnit: 27,
    parentId: 28,
    isExistGradingUnit: 29, // new Tennis
    isGameInTeamName: 30  // new Tennis
}
export const OutrightEventMap = {
  category: 'cg',
  isLiveEvent: 'ile',
  parentEventName: 'lven',
  leagueId: 'li',
  liveEvent: 'liveEvent',
  leagueName: 'ln',
  eventDate: 'lt',
  parentEventId: 'parentId',
  specialEvents: 'se',
}
export const SpecialEventMap = {
  category: 'cg',
  date: 'd',
  eventName: 'e',
  parentEventId: 'ei',
  contestantLines: 'l',
  minBet: 'm',
  specialName: 'n',
  periodNumber: 'pe',
  specialEvents: 'si',
  specialId: 'st',
  unit: 'un',
  maxBet: 'x',
  maxBetCurrency: 'xc',
  winScores: 'winScores',
  drawScores: 'drawScores',
  loseScores: 'loseScores',
  maxScoreLine: 'maxScoreLine'
}
export const CorrectScoreTypes = {
  WIN: 'WIN',
  DRAW: 'DRAW',
  LOSE: 'LOSE',
}
export const ContestantLineMap = {
  scoreTeamA: 'a',
  scoreTeamB: 'b',
  status: 's',
  contestantLineId: 'i',
  lineId: 'l',
  price: 'p',
  handicap: 'h',
  priceChange: 'c',
  rotationNumber: 'rn',
}

export const SPECIAL_LEAGUES_MAP = {
  label: 0,
  sportId: 1,
  firstMarket: 2,
  firstGameCode: 3,
  firstMarketLeagues: 4,
  marketLeagues: 5,
  gameCodeMap: 6,
  date: 7
}

export const OUTRIGHT_TYPE = {
  OUTRIGHT: 1,
  SPECIAL: 2,
  CORRECT_SCORE: 3,
  DOUBLE_CHANCE: 4,
}

export const mapFreshChatLocaleCode = {
  "en": "en",
  "de": "de",
  "fr": "fr",
  "zh-cn": "zh-HANS",
  "zh-tw": "zh-HANS",
  "id": "id",
  "vi": "vi",
  "ko": "ko",
  "th": "th",
  "es": "es"
}

export const PrefsMap = {
  timeZoneOffset: 0,
  oddsFormat: 1,
  oddsMode: 2,
  market: 3,
  order: 4,
  sportsSorting: 5,
  enableDefaultStake: 6,
  defaultStake: 7,
  acceptBetterOdds: 8,
  updateBetslipOdds: 9,
  marketFilter: 10,
  liveScoreNotify: 11,
  timeZoneId: 12,
  liveContainerOnTopEnabled: 13,
  acceptBetConfirmationModal: 14
}

export const getFreshChatLocaleByLang = (lng = '') => {
  return mapFreshChatLocaleCode[lng.toLowerCase()] || 'en';
}

export const VS_GAME_TYPE = {
  MATCH: 'MATCH',
  OUTRIGHT: 'OUTRIGHT'
}

export const EVENT_SCORE = {
  PERIOD: 0,
  SCORE: 1
}

export const VIEW = {
  STANDARD: 'FUTURE',
  CLASSIC: 'CLASSIC',
  COMPACT: 'COMPACT',
  ASIAN: 'ASIA',
  NEW_ASIAN: 'COMPACT',
  EUROPE: 'EUROPE'
}

export const TooltipActions = {
  SIGNIN: 'signIn',
  SIGNUP: 'signUp',
}

export const CASINO_GAME_TYPE_TEXT = {
  AG: 'AG Live Casino',
  AGIN: 'AGIN Live Casino'
}

export const BET_ACCEPTANCE_TYPE = {
  DANGER_ZONE: 1,
  LIVE_DELAY: 2,
  BOTH: 3
}

export const UNIFIED_ACCOUNT_FILTER_TIME_OPTIONS = {
  TODAY: 'Today',
  YESTERDAY: 'Yesterday',
  LAST_7_DAYS: 'Last seven days',
}

export const NEW_MY_BETS_DATE_OPTION = {
  TODAY: {
    value: 0,
    name: 'Today',
    status: null,
        key: 'TODAY'
  },
  TOMORROW: {
    value: 1,
    name: 'Tomorrow',
        status: 'OPEN',
        key: 'TOMORROW'
  },
  ALLDATES: {
    value: -1,
    name: 'All Dates',
        status: 'OPEN',
        key: 'ALL'
  },
  YESTERDAY: {
    value: -2,
    name: 'Yesterday',
        status: 'SETTLED',
        key: 'YESTERDAY'
  },
  PAST7DAYS: {
    value: -7,
    name: 'Past 7 Days',
        status: 'SETTLED',
        key: 'PAST7DAYS'
  },
  PAST4WEEKS: {
    value: -4,
    name: 'Past 4 Weeks',
        status: 'SETTLED',
        key: 'PAST4WEEKS'
  },
  PAST1MONTH: {
    value: -5,
    name: 'Past the Month',
        status: 'SETTLED',
        key: 'PAST1MONTH'
  },
  CUSTOM: {
    value: 2,
    name: 'Custom',
        status: 'SETTLED',
        key: 'CUSTOM'
  },
}

export const STATEMENT_BET_TYPES = {
    WAGER: {
        value: 'wager',
        label: 'Bet',
    },
    DEPOSIT: {
        value: 'deposit',
        label: 'Deposit',
    },
    WITHDRAWAL: {
        value: 'withdrawal',
        label: 'Withdrawal',
    },
    TRANSFER: {
        value: 'transfer',
        label: 'Transfer',
    },
    PROMOTION: {
        value: 'promotion',
        label: 'Promotion',
    },
    ADJUSTMENT: {
        value: 'adjustment',
        label: 'Adjustment',
    },
}

export const SETTLED_BETS = {
    ALL: {
        value: 'ALL',
        label: 'All',
        isSettledBet: true
    },
  WIN: {
        value: 'WIN',
    label: 'Win',
    isSettledBet: true
  },
  LOSS: {
        value: 'LOSS',
    label: 'Loss',
    isSettledBet: true
  },
  CANCELLED: {
        value: 'CANCELLED',
    label: 'Cancelled',
    isSettledBet: true
  },
  REFUNDED: {
        value: 'REFUNDED',
    label: 'Refunded',
    isSettledBet: true
  },
  REJECTED: {
        value: 'LIVE_SOCCER_REJECTED',
        label: 'Live Soccer Rejected',
        isSettledBet: true
    }
}

export const UNSETTLED_BETS = {
    ALL: {
        value: 'ALL',
        label: 'All',
        isSettledBet: false
    },
  PENDING: {
        value: 'PENDING',
    label: 'Running',
    isSettledBet: false
  },
  WAITING: {
        value: 'WAITING',
    label: 'Waiting',
    isSettledBet: false
  },
}

export const BET_TYPES = {
    ALL: {
        value: 'ALL',
        label: 'All',
    },
    SINGLE: {
        value: 'SINGLE',
        label: 'Single',
    },
    PARLAY: {
        value: 'PARLAY',
        label: 'Parlay',
    },
    TEASERS: {
        value: 'TEASER',
        label: 'Teasers',
    },
}

export const ALL = {
  value: 'ALL',
  label: 'All'
}

export const USER_TYPE = {
  PLAYER: 'PLAYER',
  CASH_PLAYER: 'CASH_PLAYER'
}

export const PERIODS_PRIORITY = {
    29: [8,39],
}

export const MINUTES_PERIODS = [33, 34, 35, 36, 37, 38];
export const CATEGORY_CODE = ["PMS","BNS","ADM","CASINO","RB"];
export const REQUEST_FORMAT_DATE = "YYYY-MM-DD HH:mm:ss";
export const STATEMENT_DEFAULT_PAGE_INDEX = 1; 
export const SHOW_NO_TOPLEAGUE_ICON = ['fatbets', 'powerbet555'];
export const ODDS_PAGE_TYPE = {
  OUTRIGHT: 'OUTRIGHT',
  TEASER: 'TEASER',
  LIVE_CENTER: 'LIVE_CENTER',
  LIVE_TV: 'LIVE_TV',
  STATS_PAGE: 'STATS_PAGE',
  VS_SPORTS: 'VS_SPORTS',
  FAVORITE: 'FAVORITE',
  SEARCH: 'SEARCH',
  HORSE_RACING: 'HORSE_RACING'
}
export const COUNTRY_CODES = [
	{name: "Afghanistan", phone_code: "+93", country_code: "AF"},
	{name: "Albania", phone_code: "+355", country_code: "AL"},
	{name: "Algeria", phone_code: "+213", country_code: "DZ"},
	{name: "American Samoa", phone_code: "+1-684", country_code: "AS"},
	{name: "Andorra", phone_code: "+376", country_code: "AD"},
	{name: "Angola", phone_code: "+244", country_code: "AO"},
	{name: "Anguilla", phone_code: "+1-264", country_code: "AI"},
	{name: "Antarctica", phone_code: "+672", country_code: "AQ"},
	{name: "Antigua and Barbuda", phone_code: "+1-268", country_code: "AG"},
	{name: "Argentina", phone_code: "+54", country_code: "AR"},
	{name: "Armenia", phone_code: "+374", country_code: "AM"},
	{name: "Aruba", phone_code: "+297", country_code: "AW"},
	{name: "Australia", phone_code: "+61", country_code: "AU"},
	{name: "Austria", phone_code: "+43", country_code: "AT"},
	{name: "Azerbaijan", phone_code: "+994", country_code: "AZ"},
	{name: "Bahamas", phone_code: "+1-242", country_code: "BS"},
	{name: "Bahrain", phone_code: "+973", country_code: "BH"},
	{name: "Bangladesh", phone_code: "+880", country_code: "BD"},
	{name: "Barbados", phone_code: "+1-246", country_code: "BB"},
	{name: "Belarus", phone_code: "+375", country_code: "BY"},
	{name: "Belgium", phone_code: "+32", country_code: "BE"},
	{name: "Belize", phone_code: "+501", country_code: "BZ"},
	{name: "Benin", phone_code: "+229", country_code: "BJ"},
	{name: "Bermuda", phone_code: "+1-441", country_code: "BM"},
	{name: "Bhutan", phone_code: "+975", country_code: "BT"},
	{name: "Bolivia", phone_code: "+591", country_code: "BO"},
	{name: "Bosnia and Herzegovina", phone_code: "+387", country_code: "BA"},
	{name: "Botswana", phone_code: "+267", country_code: "BW"},
	{name: "Brazil", phone_code: "+55", country_code: "BR"},
	{name: "British Indian Ocean Territory", phone_code: "+246", country_code: "IO"},
	{name: "British Virgin Islands", phone_code: "+1-284", country_code: "VG"},
	{name: "Brunei", phone_code: "+673", country_code: "BN"},
	{name: "Bulgaria", phone_code: "+359", country_code: "BG"},
	{name: "Burkina Faso", phone_code: "+226", country_code: "BF"},
	{name: "Burundi", phone_code: "+257", country_code: "BI"},
	{name: "Cambodia", phone_code: "+855", country_code: "KH"},
	{name: "Cameroon", phone_code: "+237", country_code: "CM"},
	{name: "Canada", phone_code: "+1", country_code: "CA"},
	{name: "Cape Verde", phone_code: "+238", country_code: "CV"},
	{name: "Cayman Islands", phone_code: "+1-345", country_code: "KY"},
	{name: "Central African Republic", phone_code: "+236", country_code: "CF"},
	{name: "Chad", phone_code: "+235", country_code: "TD"},
	{name: "Chile", phone_code: "+56", country_code: "CL"},
	{name: "China", phone_code: "+86", country_code: "CN"},
	{name: "Christmas Island", phone_code: "+6189164", country_code: "CX"},
	{name: "Cocos Islands", phone_code: "+6189162", country_code: "CC"},
	{name: "Colombia", phone_code: "+57", country_code: "CO"},
	{name: "Comoros", phone_code: "+269", country_code: "KM"},
	{name: "Cook Islands", phone_code: "+682", country_code: "CK"},
	{name: "Costa Rica", phone_code: "+506", country_code: "CR"},
	{name: "Croatia", phone_code: "+385", country_code: "HR"},
	{name: "Cuba", phone_code: "+53", country_code: "CU"},
	{name: "Curacao", phone_code: "+599", country_code: "CW"},
	{name: "Cyprus", phone_code: "+357", country_code: "CY"},
	{name: "Czech Republic", phone_code: "+420", country_code: "CZ"},
	{name: "Democratic Republic of the Congo", phone_code: "+243", country_code: "CD"},
	{name: "Denmark", phone_code: "+45", country_code: "DK"},
	{name: "Djibouti", phone_code: "+253", country_code: "DJ"},
	{name: "Dominica", phone_code: "+1-767", country_code: "DM"},
	{name: "Dominican Republic", phone_code: "+1-809", country_code: "DO"},
	{name: "Dominican Republic", phone_code: "+1-829", country_code: "DO"},
	{name: "Dominican Republic", phone_code: "+1-849", country_code: "DO"},
	{name: "East Timor", phone_code: "+670", country_code: "TL"},
	{name: "Ecuador", phone_code: "+593", country_code: "EC"},
	{name: "Egypt", phone_code: "+20", country_code: "EG"},
	{name: "El Salvador", phone_code: "+503", country_code: "SV"},
	{name: "Equatorial Guinea", phone_code: "+240", country_code: "GQ"},
	{name: "Eritrea", phone_code: "+291", country_code: "ER"},
	{name: "Estonia", phone_code: "+372", country_code: "EE"},
	{name: "Ethiopia", phone_code: "+251", country_code: "ET"},
	{name: "Falkland Islands", phone_code: "+500", country_code: "FK"},
	{name: "Faroe Islands", phone_code: "+298", country_code: "FO"},
	{name: "Fiji", phone_code: "+679", country_code: "FJ"},
	{name: "Finland", phone_code: "+358", country_code: "FI"},
	{name: "France", phone_code: "+33", country_code: "FR"},
	{name: "French Polynesia", phone_code: "+689", country_code: "PF"},
	{name: "Gabon", phone_code: "+241", country_code: "GA"},
	{name: "Gambia", phone_code: "+220", country_code: "GM"},
	{name: "Georgia", phone_code: "+995", country_code: "GE"},
	{name: "Germany", phone_code: "+49", country_code: "DE"},
	{name: "Ghana", phone_code: "+233", country_code: "GH"},
	{name: "Gibraltar", phone_code: "+350", country_code: "GI"},
	{name: "Greece", phone_code: "+30", country_code: "GR"},
	{name: "Greenland", phone_code: "+299", country_code: "GL"},
	{name: "Grenada", phone_code: "+1-473", country_code: "GD"},
	{name: "Guam", phone_code: "+1-671", country_code: "GU"},
	{name: "Guatemala", phone_code: "+502", country_code: "GT"},
	{name: "Guernsey", phone_code: "+44-1481", country_code: "GG"},
	{name: "Guinea", phone_code: "+224", country_code: "GN"},
	{name: "Guinea-Bissau", phone_code: "+245", country_code: "GW"},
	{name: "Guyana", phone_code: "+592", country_code: "GY"},
	{name: "Haiti", phone_code: "+509", country_code: "HT"},
	{name: "Honduras", phone_code: "+504", country_code: "HN"},
	{name: "Hong Kong", phone_code: "+852", country_code: "HK"},
	{name: "Hungary", phone_code: "+36", country_code: "HU"},
	{name: "Iceland", phone_code: "+354", country_code: "IS"},
	{name: "India", phone_code: "+91", country_code: "IN"},
	{name: "Indonesia", phone_code: "+62", country_code: "ID"},
	{name: "Iran", phone_code: "+98", country_code: "IR"},
	{name: "Iraq", phone_code: "+964", country_code: "IQ"},
	{name: "Ireland", phone_code: "+353", country_code: "IE"},
	{name: "Isle of Man", phone_code: "+44-1624", country_code: "IM"},
	{name: "Israel", phone_code: "+972", country_code: "IL"},
	{name: "Italy", phone_code: "+39", country_code: "IT"},
	{name: "Ivory Coast", phone_code: "+225", country_code: "CI"},
	{name: "Jamaica", phone_code: "+1-876", country_code: "JM"},
	{name: "Japan", phone_code: "+81", country_code: "JP"},
	{name: "Jersey", phone_code: "+44-1534", country_code: "JE"},
	{name: "Jordan", phone_code: "+962", country_code: "JO"},
	{name: "Kazakhstan", phone_code: "+7", country_code: "KZ"},
	{name: "Kenya", phone_code: "+254", country_code: "KE"},
	{name: "Kiribati", phone_code: "+686", country_code: "KI"},
	{name: "Kosovo", phone_code: "+383", country_code: "XK"},
	{name: "Kuwait", phone_code: "+965", country_code: "KW"},
	{name: "Kyrgyzstan", phone_code: "+996", country_code: "KG"},
	{name: "Laos", phone_code: "+856", country_code: "LA"},
	{name: "Latvia", phone_code: "+371", country_code: "LV"},
	{name: "Lebanon", phone_code: "+961", country_code: "LB"},
	{name: "Lesotho", phone_code: "+266", country_code: "LS"},
	{name: "Liberia", phone_code: "+231", country_code: "LR"},
	{name: "Libya", phone_code: "+218", country_code: "LY"},
	{name: "Liechtenstein", phone_code: "+423", country_code: "LI"},
	{name: "Lithuania", phone_code: "+370", country_code: "LT"},
	{name: "Luxembourg", phone_code: "+352", country_code: "LU"},
	{name: "Macau", phone_code: "+853", country_code: "MO"},
	{name: "Macedonia", phone_code: "+389", country_code: "MK"},
	{name: "Madagascar", phone_code: "+261", country_code: "MG"},
	{name: "Malawi", phone_code: "+265", country_code: "MW"},
	{name: "Malaysia", phone_code: "+60", country_code: "MY"},
	{name: "Maldives", phone_code: "+960", country_code: "MV"},
	{name: "Mali", phone_code: "+223", country_code: "ML"},
	{name: "Malta", phone_code: "+356", country_code: "MT"},
	{name: "Marshall Islands", phone_code: "+692", country_code: "MH"},
	{name: "Mauritania", phone_code: "+222", country_code: "MR"},
	{name: "Mauritius", phone_code: "+230", country_code: "MU"},
	{name: "Mayotte", phone_code: "+262", country_code: "YT"},
	{name: "Mexico", phone_code: "+52", country_code: "MX"},
	{name: "Micronesia", phone_code: "+691", country_code: "FM"},
	{name: "Moldova", phone_code: "+373", country_code: "MD"},
	{name: "Monaco", phone_code: "+377", country_code: "MC"},
	{name: "Mongolia", phone_code: "+976", country_code: "MN"},
	{name: "Montenegro", phone_code: "+382", country_code: "ME"},
	{name: "Montserrat", phone_code: "+1-664", country_code: "MS"},
	{name: "Morocco", phone_code: "+212", country_code: "MA"},
	{name: "Mozambique", phone_code: "+258", country_code: "MZ"},
	{name: "Myanmar", phone_code: "+95", country_code: "MM"},
	{name: "Namibia", phone_code: "+264", country_code: "NA"},
	{name: "Nauru", phone_code: "+674", country_code: "NR"},
	{name: "Nepal", phone_code: "+977", country_code: "NP"},
	{name: "Netherlands", phone_code: "+31", country_code: "NL"},
	{name: "Netherlands Antilles", phone_code: "+599", country_code: "AN"},
	{name: "New Caledonia", phone_code: "+687", country_code: "NC"},
	{name: "New Zealand", phone_code: "+64", country_code: "NZ"},
	{name: "Nicaragua", phone_code: "+81", country_code: "NI"},
	{name: "Niger", phone_code: "+227", country_code: "NE"},
	{name: "Nigeria", phone_code: "+234", country_code: "NG"},
	{name: "Niue", phone_code: "+683", country_code: "NU"},
	{name: "Northern Mariana Islands", phone_code: "+1-670", country_code: "MP"},
	{name: "North Korea", phone_code: "+850", country_code: "KP"},
	{name: "Norway", phone_code: "+47", country_code: "NO"},
	{name: "Oman", phone_code: "+968", country_code: "OM"},
	{name: "Pakistan", phone_code: "+92", country_code: "PK"},
	{name: "Palau", phone_code: "+680", country_code: "PW"},
	{name: "Palestine", phone_code: "+970", country_code: "PS"},
	{name: "Panama", phone_code: "+507", country_code: "PA"},
	{name: "Papua New Guinea", phone_code: "+675", country_code: "PG"},
	{name: "Paraguay", phone_code: "+595", country_code: "PY"},
	{name: "Peru", phone_code: "+51", country_code: "PE"},
	{name: "Philippines", phone_code: "+63", country_code: "PH"},
	{name: "Pitcairn", phone_code: "+64", country_code: "PN"},
	{name: "Poland", phone_code: "+48", country_code: "PL"},
	{name: "Portugal", phone_code: "+351", country_code: "PT"},
	{name: "Puerto Rico", phone_code: "+1-787", country_code: "PR"},
	{name: "Puerto Rico", phone_code: "+1-939", country_code: "PR"},
	{name: "Qatar", phone_code: "+974", country_code: "QA"},
	{name: "Republic of the Congo", phone_code: "+242", country_code: "CG"},
	{name: "Reunion", phone_code: "+262", country_code: "RE"},
	{name: "Romania", phone_code: "+40", country_code: "RO"},
	{name: "Russia", phone_code: "+7", country_code: "RU"},
	{name: "Rwanda", phone_code: "+250", country_code: "RW"},
	{name: "Saint Barthelemy", phone_code: "+590", country_code: "BL"},
	{name: "Saint Helena", phone_code: "+290", country_code: "SH"},
	{name: "Saint Kitts and Nevis", phone_code: "+1-869", country_code: "KN"},
	{name: "Saint Lucia", phone_code: "+1-758", country_code: "LC"},
	{name: "Saint Martin", phone_code: "+590", country_code: "MF"},
	{name: "Saint Pierre and Miquelon", phone_code: "+508", country_code: "PM"},
	{name: "Saint Vincent and the Grenadines", phone_code: "+1-784", country_code: "VC"},
	{name: "Samoa", phone_code: "+685", country_code: "WS"},
	{name: "San Marino", phone_code: "+378", country_code: "SM"},
	{name: "Sao Tome and Principe", phone_code: "+239", country_code: "ST"},
	{name: "Saudi Arabia", phone_code: "+966", country_code: "SA"},
	{name: "Senegal", phone_code: "+221", country_code: "SN"},
	{name: "Serbia", phone_code: "+381", country_code: "RS"},
	{name: "Seychelles", phone_code: "+248", country_code: "SC"},
	{name: "Sierra Leone", phone_code: "+232", country_code: "SL"},
	{name: "Singapore", phone_code: "+65", country_code: "SG"},
	{name: "Sint Maarten", phone_code: "+1-721", country_code: "SX"},
	{name: "Slovakia", phone_code: "+421", country_code: "SK"},
	{name: "Slovenia", phone_code: "+386", country_code: "SI"},
	{name: "Solomon Islands", phone_code: "+677", country_code: "SB"},
	{name: "Somalia", phone_code: "+252", country_code: "SO"},
	{name: "South Africa", phone_code: "+27", country_code: "ZA"},
	{name: "South Korea", phone_code: "+82", country_code: "KR"},
	{name: "South Sudan", phone_code: "+211", country_code: "SS"},
	{name: "Spain", phone_code: "+34", country_code: "ES"},
	{name: "Sri Lanka", phone_code: "+94", country_code: "LK"},
	{name: "Sudan", phone_code: "+249", country_code: "SD"},
	{name: "Suriname", phone_code: "+597", country_code: "SR"},
	{name: "Svalbard and Jan Mayen", phone_code: "+47", country_code: "SJ"},
	{name: "Swaziland", phone_code: "+268", country_code: "SZ"},
	{name: "Sweden", phone_code: "+46", country_code: "SE"},
	{name: "Switzerland", phone_code: "+41", country_code: "CH"},
	{name: "Syria", phone_code: "+963", country_code: "SY"},
	{name: "Taiwan", phone_code: "+886", country_code: "TW"},
	{name: "Tajikistan", phone_code: "+992", country_code: "TJ"},
	{name: "Tanzania", phone_code: "+255", country_code: "TZ"},
	{name: "Thailand", phone_code: "+66", country_code: "TH"},
	{name: "Togo", phone_code: "+228", country_code: "TG"},
	{name: "Tokelau", phone_code: "+690", country_code: "TK"},
	{name: "Tonga", phone_code: "+676", country_code: "TO"},
	{name: "Trinidad and Tobago", phone_code: "+1-868", country_code: "TT"},
	{name: "Tunisia", phone_code: "+216", country_code: "TN"},
	{name: "Turkey", phone_code: "+90", country_code: "TR"},
	{name: "Turkmenistan", phone_code: "+993", country_code: "TM"},
	{name: "Turks and Caicos Islands", phone_code: "+1-649", country_code: "TC"},
	{name: "Tuvalu", phone_code: "+688", country_code: "TV"},
	{name: "U.S. Virgin Islands", phone_code: "+1340", country_code: "VI"},
	{name: "Uganda", phone_code: "+256", country_code: "UG"},
	{name: "Ukraine", phone_code: "+380", country_code: "UA"},
	{name: "United Arab Emirates", phone_code: "+971", country_code: "AE"},
	{name: "United Kingdom", phone_code: "+44", country_code: "GB"},
	{name: "United States", phone_code: "+1", country_code: "US"},
	{name: "Uruguay", phone_code: "+598", country_code: "UY"},
	{name: "Uzbekistan", phone_code: "+998", country_code: "UZ"},
	{name: "Vanuatu", phone_code: "+678", country_code: "VU"},
	{name: "Vatican", phone_code: "+379", country_code: "VA"},
	{name: "Venezuela", phone_code: "+58", country_code: "VE"},
	{name: "Vietnam", phone_code: "+84", country_code: "VN"},
	{name: "Wallis and Futuna", phone_code: "+681", country_code: "WF"},
	{name: "Western Sahara", phone_code: "+212", country_code: "EH"},
	{name: "Yemen", phone_code: "+967", country_code: "YE"},
	{name: "Zambia", phone_code: "+260", country_code: "ZM"},
	{name: "Zimbabwe", phone_code: "+263", country_code: "ZW"}
];


export const SimplifiedOriginalBetType = {
  MONEYLINE: "MONEYLINE",
  SPREAD: "SPREAD",
  TOTAL_POINTS: "TOTAL_POINTS",
  TEAM_TOTAL_POINTS: "TEAM_TOTAL_POINTS",
  SPECIALS:  "SPECIALS",
  OUTRIGHT: "OUTRIGHT"
};

export const SimplifiedBetType = {
  MONEYLINE: 1,
  SPREAD: 2,
  TOTAL_POINTS: 3,
  HOME_TEAM_TOTAL_POINTS: 4,
  AWAY_TEAM_TOTAL_POINTS: 5,
  SPECIALS: 99,
  OUTRIGHT: 99
}

export const SimplifiedSelectionType = {
  HOME: 0,
  AWAY: 1,
  DRAW: 2,
  OVER_TOTAL_POINTS: 3,
  UNDER_TOTAL_POINTS: 4,
  HOME_OVER_TEAM_TOTAL_POINTS: 5,
  HOME_UNDER_TEAM_TOTAL_POINTS: 6,
  AWAY_OVER_TEAM_TOTAL_POINTS: 7,
  AWAY_UNDER_TEAM_TOTAL_POINTS: 8,
  OUTRIGHT: 10
}

//Format URL in Banner: domain/locale/(casino|live-casino)/product/gameId
export const POSITION_CASINO_PATH = {
    PRODUCT_CODE_PATH: 5,
    GAME_ID: 6,
    CASINO_PATH: 4
}

// status_1: show odd, status_2: hide odd
export const PERIOD_STATUS = ["status_1", "status_2"];

export const DESTINATION_WS = {
    LEFT_MENU: "LEFT_MENU",
    ODDS: "ODDS",
    LIVE_SCORE: "LIVE_SCORE",
    ALL: "ALL",
    SPECIAL_ODDS: "SPECIAL_ODDS"
}

export const MESSAGES_TYPE_WS = {
    PING: "PING",
    PONG: "PONG",
    SUBSCRIBE: "SUBSCRIBE",
    UNSUBSCRIBE: "UNSUBSCRIBE",
    RESET_CONNECTION: "RESET_CONNECTION",
    WEBSOCKET_DISABLED: "WEBSOCKET_DISABLED",
    LIVE_SCORE_NOTIFIER_DISABLED: "LIVE_SCORE_NOTIFIER_DISABLED"
}

export const MESSAGES_LEFT_MENU_WS = {
    FULL_LEFT_MENU: "FULL_LEFT_MENU",
    UPDATE_LEFT_MENU: "UPDATE_LEFT_MENU",
    UPDATE_GROUPS_OUTRIGHT: "UPDATE_GROUPS_OUTRIGHT",
    UPDATE_GROUPS_TEASER: "UPDATE_GROUPS_TEASER",
    UPDATE_SPECIAL_LEAGUES: "UPDATE_SPECIAL_LEAGUES",
    UPDATE_NUM_LIVE_TV: "UPDATE_NUM_LIVE_TV",
    LEFT_MENU_DISABLED: "LEFT_MENU_DISABLED"
}
export const MESSAGES_ODD_PAGE_WS = {
    FULL_ODDS: "FULL_ODDS",
    UPDATE_ODDS: "UPDATE_ODDS",
    ODDS_DISABLED: "ODDS_DISABLED",
    MORE_BET: "MORE_BET",
    UN_MORE_BET: "UN_MORE_BET",
    SPECIAL_DISABLED: "SPECIAL_DISABLED"
}

export const CHANEL = {
    DESKTOP: 'desktop',
};

export let NAV_ITEM_LIST_MENU = {};

export const PRESTIGE_KEYS = {
    HEADER: 'header',
    CONTENT: 'content',
    BUTTON: 'button',
    TEXT_EXPAND: 'text_expand'
  };

export const SUPPORTED_SPORTID_MATCHUP_PAGE = [29]

export const STATS_PATH = '/:lang([a-z]{2}|[a-z]{2}-[a-z]{2})/:view/sports/:sportName/stats/:leagueName/:eventName/:eventId'
export const STATS_PATH_WITHOUT_VIEW = '/:lang([a-z]{2}|[a-z]{2}-[a-z]{2})/sports/:sportName/stats/:leagueName/:eventName/:eventId'
export const SIMULATED_LOADING_TIMEOUT = 1000;

export const standardizeEventParamsMap = {
  'sp': EMPTY_VALUE, // sportID
  'lg': EMPTY_VALUE, // leagueID
  'ev': EMPTY_VALUE, // eventID
  'mk': 1, // market
  'btg': 1, // bet type group
  'ot': 1, // odds type
  'd': EMPTY_VALUE, // date
  'o': 0, // event order
  'l': 2, // max line
  'v': EMPTY_VALUE, // version
  'lv': EMPTY_VALUE, // live version
  'me': 0, // more bet event 
  'more': false, // return full odds data of param me
  'lang': EMPTY_VALUE, // If locale params is empty, sports-webservice will look at this parameter
  'tm': 0, // time range
  'pa': 0, // will be return parlay if value is 1
  'c': 'Others', // Country. This param is used to filter out block sport by country config in the System config
  'g': EMPTY_VALUE, // Odds Group of user. Used for odds line fattening
  'pn': -1, // Filter for Period number. Used to filter returned period odds data. If -1, return all periods
  'ec': EMPTY_VALUE, // ESport Code. If sp==12 and ec != empty, filter returned odds with ESport Code
  'cl': -1, // Current number of line is displaying on UI
  'hle': true, // Return sp highlight events or not
  'pimo': EMPTY_VALUE, // Period in main odds. Period Numbers are separated by ,. The param presents for displaying period in odds page. This param used for getting more bet event data. API returns the rest of event periods from the displaying periods
  'inl': false, // Is New Layout. This parameter is used for Tennis sport displaying purposes. Force API always returns ML data for events
  'pv': 1 // to monitor invalid requests from BOT
}

export const TEAM_PROPS_PERIODS_PRIORITY = {
  29: [8],
}

export const ODDS_CONTAINER_TYPE = {
  LIVE: "LIVE_CONTAINER",
  HIGHLIGHT: "HIGHLIGHT_CONTAINER",
  EARLY: "EARLY_CONTAINER",
  TODAY: "TODAY_CONTAINER",
}

export const ODDS_CONTAINER_CATEGORY = {
  MAIN: "MAIN",
  MORE: "MORE"
}

export const MAIN_PAGE = {
  SPORT: "SPORT",
  ESPORT: "ESPORT",
  LIVE_SPORT: "LIVE_SPORT",
  LIVE_ESPORT: "LIVE_ESPORT",
  FAVORITES: "FAVOURITES",
  SEARCH: "SEARCH",
  PROMOTED_ENTITY: "PROMOTED_ENTITY",
  EVENT: "EVENT",
  LIVE_CENTER: "LIVE_CENTER",
  LIVE_STREAMING: "LIVE_STREAMING",
  LEAGUE: "LEAGUE",
}

export const PREFIX_SPORT_TRANSLATION  = {
   3: 'baseball',
   4: 'basketball',
   29: 'soccer',
   33: 'tennis'
}

export const BET_LOCATION_UNKNOWN = "UNKNOWN";


// WEBPACK FOOTER //
// ./src/app/common/Foundation.js